import { useTranslation } from 'react-i18next';
import CentrosBase from './CentrosBase';

const Servicos = () => {
    const { t } = useTranslation();

    return (
        <CentrosBase centroNome={'SERVIÇOS'} 
        centroDescricao={t('CentrosBase.servicoDescricao')} 
        tipo={'SERVICO'} 
        excludedCountries={['PERU', 'URUGUAI']}/>
    );
};

export default Servicos;